























































import Vue, { PropType } from 'vue'
import { IRoom } from '@/models/IRoom'
import ReservationCountDown from './ReservationCountDown.vue'

export default Vue.extend({
  name: 'RoomDynamicCard',
  components: { ReservationCountDown },
  props: {
    room: {
      type: Object as PropType<IRoom>,
      required: true
    },
    adminMode: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  data: () => ({
    showDetails: false
  }),
  computed: {
    isFull(): boolean {
      return this.room.size === this.room.students.length
    },
    isCurrentUserReservation(): boolean {
      return this.$store.state.user.meta === this.room.reservedMeta
    }
  },
  methods: {
    expandRoom() {
      this.showDetails = this.showDetails ? false : true
    }
  }
})
